import { useState } from 'react';
import { api } from '../api';
import { Link } from '../router';
import { useSession } from '../session';
import { useData } from '../useData';
import { Shell } from '../components/Shell';
import { Empty, Loading } from '../components/bits';

/** Every client, and the way in to one.
 *
 *  Until now a client could only be made by hand in the database, which meant
 *  onboarding one needed somebody with psql. */
export function Clients() {
  const { t } = useSession();
  const [adding, setAdding] = useState(false);
  const clients = useData(() => api.workspaces(), []);

  return (
    <Shell>
      <div className="page-head">
        <div className="grow">
          <p className="kicker">{clients.data?.length ?? 0}</p>
          <h1>{t.clients}</h1>
        </div>
        <button className="primary" onClick={() => setAdding((v) => !v)}>
          {adding ? t.cancel : `${t.newClient} >`}
        </button>
      </div>

      {adding && <AddClient onDone={() => { setAdding(false); clients.reload(); }} />}

      {clients.loading && !clients.data ? <Loading /> : null}
      {clients.data?.length === 0 ? <Empty>{t.noProjects}</Empty> : null}

      <div className="cards">
        {clients.data?.map((c) => (
          <Link to={`/clients/${c.id}`} className="card" key={c.id}>
            <h3>{c.name}</h3>
            <p className="muted" style={{ margin: 0, fontSize: 13 }}>
              {t.projectCount(c.projectCount)}
            </p>
          </Link>
        ))}
      </div>
    </Shell>
  );
}

function AddClient({ onDone }: { onDone: () => void }) {
  const { t } = useSession();
  const [name, setName] = useState('');
  const [busy, setBusy] = useState(false);
  const [problem, setProblem] = useState<string | null>(null);

  const submit = async (event: React.FormEvent) => {
    event.preventDefault();
    setBusy(true);
    setProblem(null);
    try {
      await api.createWorkspace({ name });
      setName('');
      onDone();
    } catch (err) {
      setProblem(err instanceof Error ? err.message : String(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <form onSubmit={submit} className="card stack" style={{ marginBottom: 'var(--sp-5)' }}>
      <div style={{ maxWidth: 420 }}>
        <label htmlFor="c-name">{t.clientName}</label>
        <input id="c-name" required autoFocus value={name} onChange={(e) => setName(e.target.value)} />
      </div>
      {problem && <p className="error" role="alert">{problem}</p>}
      <div className="row">
        <button className="primary" type="submit" disabled={busy || !name.trim()}>{t.create} &gt;</button>
      </div>
    </form>
  );
}
